export default __webpack_public_path__ + "static/media/privilege-wheel-yellow.8b635c61.svg";